const summary = "AccountMenu-module_summary_JKbozLcP";
const content = "AccountMenu-module_content_q9dF4g-C";
const email = "AccountMenu-module_email_rb78eluQ";
const list = "AccountMenu-module_list_BmoIsgb2";
const link = "AccountMenu-module_link_V-biy4oL";
const selected = "AccountMenu-module_selected_21Z44SyR";
const accountTextContainer = "AccountMenu-module_accountTextContainer_sdnZoEoJ";
const styles = {
  summary,
  content,
  email,
  list,
  link,
  selected,
  accountTextContainer
};
export {
  accountTextContainer,
  content,
  styles as default,
  email,
  link,
  list,
  selected,
  summary
};
